import { STAFF_MODULES, type StaffModuleCode } from '../../config/staffModules'

type StaffModulePickerProps = {
  value: StaffModuleCode[]
  onChange: (next: StaffModuleCode[]) => void
  disabled?: boolean
}

export function StaffModulePicker({ value, onChange, disabled = false }: StaffModulePickerProps) {
  const selected = new Set(value)

  function toggle(code: StaffModuleCode) {
    if (disabled) return
    const next = new Set(selected)
    if (next.has(code)) next.delete(code)
    else next.add(code)
    onChange([...next] as StaffModuleCode[])
  }

  return (
    <fieldset className="space-y-2" disabled={disabled}>
      <legend className="text-sm font-medium text-foreground">Module access</legend>
      <p className="text-xs text-muted-foreground">
        Choose which areas of store admin this staff member can use.
      </p>
      <div className="grid gap-2 sm:grid-cols-2">
        {STAFF_MODULES.map((mod) => (
          <label
            key={mod.code}
            className="flex cursor-pointer items-start gap-3 rounded-xl border border-border bg-background px-3 py-2.5 has-[:checked]:border-primary/40 has-[:checked]:bg-primary/5"
          >
            <input
              type="checkbox"
              className="mt-0.5 h-4 w-4 rounded border-input text-primary focus:ring-ring"
              checked={selected.has(mod.code)}
              onChange={() => toggle(mod.code)}
            />
            <span className="min-w-0">
              <span className="block text-sm font-medium text-foreground">{mod.label}</span>
              <span className="block text-xs text-muted-foreground">{mod.description}</span>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  )
}
